import { PopoverPortalContext } from "@circle-react-shared/uikit/PopoverPortal";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useChatNotification } from "@circle-react/hooks/chatsV2/useChatNotification";
import { Popover as CompassPopover } from "@circleco/compass/components/Popover";
import { useLocation } from "@tanstack/react-router";
import { useEffect, useMemo, useState } from "react";

import { t } from "@/i18n-js/instance";
import { useElectronNotification } from "@/react/hooks/notifications/useElectronNotification";

import { HeaderIconButton } from "../HeaderIconButton";
import { formatNotificationsCount } from "../utils";
import { Banner } from "./Banner";
import { Header } from "./Header";
import { TabHeader } from "./TabHeader";

export const DirectMessagesPopover = () => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const { unreadChatCount } = useChatNotification();
  const { setDesktopAppUnreadMessageCount } = useElectronNotification();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const popoverPortalContextValue = useMemo(
    () => ({ onClose: () => setIsOpen(false) }),
    [],
  );

  useEffect(() => {
    setDesktopAppUnreadMessageCount(unreadChatCount);
  }, [unreadChatCount, setDesktopAppUnreadMessageCount]);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <CompassPopover
      trigger={
        <HeaderIconButton
          icon="message"
          ariaLabel={t("header_v3.direct_messages")}
          hotkey="alt+m"
          counter={
            unreadChatCount > 0
              ? formatNotificationsCount(unreadChatCount)
              : undefined
          }
          isOpen={isOpen}
          data-testid="direct-messages-popover-button"
        />
      }
      open={isOpen}
      onOpenChange={setIsOpen}
      side="bottom"
      align="end"
      sideOffset={4}
      fillAvailableHeight
      className={classNames(
        "size-full max-h-[37rem] min-h-[37rem] min-w-[30rem] max-w-[30rem] p-0",
        {
          "cursor-not-allowed": isViewOnlyMasquerading,
        },
      )}
    >
      <PopoverPortalContext.Provider value={popoverPortalContextValue}>
        <div
          className={classNames("size-full overflow-hidden rounded-md", {
            "pointer-events-none": isViewOnlyMasquerading,
          })}
          data-testid="direct-messages-drawer"
        >
          <Banner />
          <Header />
          <TabHeader />
        </div>
      </PopoverPortalContext.Provider>
    </CompassPopover>
  );
};
